import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { Nav, NavItem, Navbar, NavDropdown, MenuItem} from 'react-bootstrap';
import { logoutPressed } from '../actions';
import logo from '../../resources/images/logo_grey.png'
import {userIsAdmin, userIsGroupAdmin} from '../constants'

class NavBar extends Component {

    handleLogout = () => {
        this.props.dispatch(logoutPressed())
    }
    onReportPress = () =>{
        browserHistory.push("/report");
    }

    render() {
        const currentPage = this.props.routing.locationBeforeTransitions.pathname;
        const admin = userIsAdmin(this.props.user)
        const teamAdmin = userIsGroupAdmin(this.props.user)

        return (
            <Navbar collapseOnSelect fixedTop>
                <Navbar.Header>
                    <Navbar.Brand>
                        <a onClick={() => browserHistory.push('/dashboard')}>
                            <img src={logo} alt="logo" style={{width: '120px', height: '60px'}}/>
                        </a>
                    </Navbar.Brand>
                    <Navbar.Toggle />
                </Navbar.Header>
                <Navbar.Collapse>
                    <Nav pullRight activeKey={currentPage} onSelect={this.handleSelect}>
                        {this.props.loggedIn && <NavItem onClick={this.onReportPress}>Report</NavItem>}
                        {this.props.user ?
                            <NavDropdown eventKey={1} title={`${this.props.user.name || 'user'}`} id="basic-nav-dropdown">
                                {this.props.loggedIn && <MenuItem onClick={() => browserHistory.push('/dashboard')}>Dashboard</MenuItem>}
                                {this.props.loggedIn && <MenuItem onClick={() => browserHistory.push('/account')}>Account</MenuItem>}
                                {(admin || teamAdmin) && <MenuItem onClick={() => browserHistory.push('/admin')}>Admin</MenuItem>}
                                <MenuItem onClick={() => browserHistory.push('/support')}>Support</MenuItem>
                                <MenuItem onClick={this.handleLogout}>Log out</MenuItem>
                            </NavDropdown>
                            : !this.props.loading['getETMSUser'] ? <NavItem onClick={this.handleLogout}>Log out</NavItem>
                            : <NavItem>{'\u00A0'/*placeholder while loading*/}</NavItem>}
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        );
    }
}

NavBar = connect((state) => {
    return {
        routing: state.routing || {},
        loading: (state.data || {}).loading || {}
    }
})(NavBar);

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/NavBar.jsx